import {FieldType} from "../../fields3/field-type";
import FieldsCollection from "../../fields3/collection/base/fields-collection";
import {EntityType} from "../../gd/const/item";
import FieldString from "../../fields3/generic/string/string";
import FieldText from "../../fields3/generic/text/text";

export default class ReportFields extends FieldsCollection {

    constructor() {

        const fieldsConfig = [
            {
                fieldId : 'name',
                type    : FieldType.STRING,
                label   : 'Name'
            },

            {
                fieldId : 'description',
                type    : FieldType.TEXT,
                label   : 'Description'
            },
        ]

        super(fieldsConfig, EntityType.DYNAMIC_MODEL);
    }

    get name()              { return this.get('name') as FieldString }
    get description()       { return this.get('description') as FieldText }

}
